import api from '../../helpers/api';
import moment from 'moment';

import {
  SET_SERVICIOS_IDA,
  SET_SERVICIOS_VUELTA,
  FILTRAR_SERVICIOS,
  SET_BUSQUEDA,
  RESET_BUSQUEDA,
  SET_SERVICIO_IDA_SELECTED,
  SET_SERVICIO_VUELTA_SELECTED,
  SET_VIAJE_VUELTA_ACTIVO,
  ERROR_BUSQUEDA_SERVICIOS,
  SET_MENSAJE_RANGO,
} from '../types';

const setterBusquedaAction = (busqueda) => ({
  type: SET_BUSQUEDA,
  payload: busqueda,
});

export const resetBusquedaAction = () => ({
  type: RESET_BUSQUEDA,
});

const setServiciosIdaAction = (servicios) => ({
  type: SET_SERVICIOS_IDA,
  payload: servicios,
});

const setServiciosVueltaAction = (servicios) => ({
  type: SET_SERVICIOS_VUELTA,
  payload: servicios,
});

export const filterServiciosAction = (cantidad) => ({
  type: FILTRAR_SERVICIOS,
  payload: cantidad,
});

export const setSelectedServicioIda = (item) => ({
  type: SET_SERVICIO_IDA_SELECTED,
  payload: item,
});

export const setSelectedServicioVuelta = (item) => ({
  type: SET_SERVICIO_VUELTA_SELECTED,
  payload: item,
});

export const viajeDeVueltaActivaAction = () => ({
  type: SET_VIAJE_VUELTA_ACTIVO,
});

const setMensajeRangoAction = (m) => ({
  type: SET_VIAJE_VUELTA_ACTIVO,
  payload: m,
});

const errorBuscarServiciosAction = (e) => ({
  type: ERROR_BUSQUEDA_SERVICIOS,
  payload: e,
});

export const setterBusqueda = (data) => {
  return async (dispatch) => {
    try {
      dispatch(setterBusquedaAction(data));
    } catch (ex) {
      dispatch(
        errorBuscarServiciosAction({
          message: 'Algo salio mal ',
        })
      );
    }
  };
};

export const getServicios = (data) => {
  return async (dispatch) => {
    try {
      const {
        linea,
        fecha,
        hora,
        horarioAprox,
        estacionOrigen,
        estacionDestino,
      } = data.query.busqueda;

      const fechaString = moment(fecha).format('YYYY-MM-DD');
      const horaString = moment(hora).format('HH:mm');
      const fechaBuscar = moment(`${fechaString}T${horaString}`).toISOString();

      const body = {
        fecha: fechaBuscar,
        tipo: horarioAprox,
        desdeId: parseInt(estacionOrigen),
        hastaId: parseInt(estacionDestino),
        cantidad: parseInt(data.query.cantidad),
      };

      const servicios = await api.post('v1/servicios/buscar', body, {
        headers: {
          Authorization: data.token,
        },
      });

      if (data.ida) {
        dispatch(setServiciosIdaAction(servicios.data));
      } else {
        dispatch(setServiciosVueltaAction(servicios.data));
      }
      dispatch(
        filterServiciosAction({ cantidad: 0, numeroTrenFiltro: data.numeroTrenFiltro })
      );
    } catch (ex) {
      dispatch(
        errorBuscarServiciosAction({
          message: 'Algo salio mal',
        })
      );
    }
  };
};
